import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { startMockWorker } from './mock/start';
import { AppProviders } from './providers';
import { AppRouter } from './router';
import './styles/global.css';

const container = document.getElementById('root');
if (!container) {
  throw new Error('root 엘리먼트를 찾을 수 없습니다 — public/index.html 을 확인하세요');
}

// 목 서버가 뜨기 전에 렌더하면 첫 요청이 그대로 네트워크로 나간다 — 기동을 기다린다
void startMockWorker().then(() => {
  createRoot(container).render(
    <StrictMode>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </StrictMode>,
  );
});
